import { Injectable } from "@angular/core";
import { HttpRequest, HttpErrorResponse, HttpResponse, HttpInterceptor, HttpHandler, HttpEvent } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { SnackBarService } from "../core/snack-bar.service";

@Injectable()
export class UnauthRedirectInterceptor implements HttpInterceptor {

    constructor(private router: Router) { }

    // see https://medium.com/@ryanchenkie_40935/angular-authentication-using-the-http-client-and-http-interceptors-2f9d1540eb8

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(req)
            .pipe(
            tap((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // do stuff with response if you want
                }
            }, (err: any) => {
                // todo: logic to use refresh token would go here instead of just redirecting...
                if (err instanceof HttpErrorResponse) {
                    if (err.status === 401 || err.status === 403) {
                        this.router.navigate(["/login"]);
                    }
                }
            }));
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/auth/unauth-redirect.interceptor.ts